import { useQuery } from "react-query";
import { listEmployeeScheduling } from "../api/server";

const fetchEmployeeScheduling = async ({ queryKey }) => {
  const [, { startDate, endDate, employee, scopePrefix }] = queryKey;

  const newState = {
    current: 1,
    pageSize: 100,
    filter: {
      date: {
        $gt: startDate,
        $lt: endDate,
      },
    },
  };
  const listParams = {
    ...newState,
    scopePrefix,
    employeeId: employee?.id,
  };
  if (startDate && endDate && employee?.id) {
    const scheduling = await listEmployeeScheduling(listParams);
    const { effective_orders, items } = scheduling.data;
    let events = [];
    if (items && items.length > 0) {
      items.forEach((item) => {
        let temp = { ...item };

        if (effective_orders && effective_orders.length > 0) {
          const order = effective_orders.find((i) => i.id === item.order_id);
          temp.patient = order?.patient;
        }
        events.push(temp);
      });
    }
    return events;
  }

  return [];
};

const useMatching = (
  startDate,
  endDate,
  employee,
  scopePrefix,
  type,
  recurrent_event_conflicts
) => {
  const {
    data,
    isLoading: loading,
    error,
  } = useQuery(
    ["employeeScheduling", { startDate, endDate, employee, scopePrefix }],
    fetchEmployeeScheduling
  );

  let finalData = data;

  if (type === "plan") {
    const reccurentEvents =
      recurrent_event_conflicts && recurrent_event_conflicts.length > 0
        ? recurrent_event_conflicts.map((i) => {
            return {
              ...i,
              ...i.order,
            };
          })
        : [];
    finalData = reccurentEvents;
  }

  return { conflicts: finalData, conflictsLoading: loading, error };
};

export default useMatching;
